import { styled } from "@mui/material/styles";
import Tab from "@mui/material/Tab";

const CustomTab = styled(Tab)({
  textTransform: "none",
  fontSize: 18,
  "&.Mui-selected": {
    color: "#457dd9 !important",
  },
});

export default CustomTab;
